<template>
	<div >
		<footer>
			<div class="index-content">
				<div class="footer-logo">
					<div class="footer-logo-image">
						<img :src="config.footer_company">
					</div>
					<div class="footer-logo-info">
						<div class="footer-title">
							{{config.company_name}}
						</div>
						<div class="footer-add">
							电话：{{config.tel}}
						</div>
						<div class="footer-tel">
							邮箱：{{config.email}}
						</div>
						<div class="footer-tel">
							地址：{{config.address}}
						</div>
					</div>
				</div>

				<div class="footer-list">
					<div class="footer-list-content" v-for="(item,index) in data" :key="index">
						<div class="footer-list-top" @click="url(item.href)">
							<img :src="item.icon" class="icon">
							<p>{{item.name}}</p>
						</div>

						<ul class="nav">
							<li v-for="(item2,index2) in item.child" :key="index2" @click="url(item2.href)">
								<a href="javascript:;" @click="url(item.href)">{{item2.name}}</a>
							</li>
						</ul>
					</div>

                    <div class="footer-qr">
                        <img :src="config.site_qr">
                        <img :src="config.contact_qr">
                    </div>
				</div>

                

				<div class="footer-copy">
					<div class="footer-copy-no">
						<a href="http://beian.miit.gov.cn/" target="_blank">{{config.icp}}</a>
					</div>
					<div class="footer-copy-info">
						{{config.copy}}
					</div>
				</div>
			</div>
		</footer>
		</div>
	
	</div>
</template>

<script>
	import {common_nav,common_config} from '@/api/common.js';
	export default {
		name: 'commonFooter',
		data() {
			return {
				data:[],
				config:{},
			}
		},
		created() {
			this.get_data();
			this.get_config();
		},
		methods: {
			get_data(){
				common_nav({nav_id:2}).then(res=>{
					if(res.code==1){
						this.data = res.data;
					}
				});
			},

			get_config(){
				common_config({}).then(res=>{
					if(res.code==1){
						this.config = res.data;
					}
				});
			},

			url(path){
				if(path.indexOf("http") != -1){
					window.location.href = path;
				}else{
					this.$router.push(path);
				}
			},
		}
	}
</script>
<style scoped>
	.index-content{
		width: 1300px;
		margin: 0 auto;
	}

	footer {
		background: #3d3d3d;
		height: 500px;
		color: #fff;
		width: 100%;
		min-width: 1200px;
	}

	footer .index-content {
		position: relative;
		height: 500px;
		overflow: hidden;
	}

	.footer-logo {
		width: 300px;
		height: 350px;
		position: absolute;
		left: 0;
		top: 80px;
	}

	.footer-logo-image img {
		width: 260px;
	}

	.footer-list {
		width: 1000px;
		height: 320px;
		position: absolute;
		left: 350px;
		top: 70px;
	}

	.footer-list-content {
		display: inline-block;
		border-right: 2px solid #aaa;
		text-align: center;
		width: 260px;
		vertical-align: top;
		height: 220px;
	}

	.footer-list-content ul {
		margin-top: 30px;
	}


	.footer-list-content ul li {
		margin-bottom: 10px;
	}

	.footer-list-top p {
		font-size: 20px;
		font-weight: 600;
	}

	.footer-list-top img {
		height: 32px;
	}

	.footer-logo-info {
		margin-top: 40px;
	}


	.footer-logo-info .footer-title {
		font-size: 18px;
		font-weight: 800;
	}


	.footer-logo-info .footer-add {
		margin-top: 20px;
		font-size: 14px;
		font-weight: 200;
	}

	.footer-logo-info .footer-tel {
		margin-top: 20px;
		font-size: 14px;
		font-weight: 200;
	}


	.footer-qr {
		display: inline-block;
		/* position: absolute;
		right: 0;
		top: 50px; */
		width: 100px;
        margin-left: 50px;
	}

	.footer-qr img {
		width: 100px;
		margin-bottom: 20px;
        margin-right: 20px;
	}


	.footer-copy {
		text-align: center;
		position: absolute;
		height: 100px;
		width: 1300px;
		left: 0;
		bottom: 0;
		color: #666;
		font-size: 14px;
	}
	.footer-copy-no{
		margin-bottom: 10px;
	}
	.footer-copy-no a {
		color: #666;
		text-decoration: none;
	}
	.footer-copy-no a:hover{
		color: #888;
	}
	.nav{
		padding: 0;
	}
	.nav li{
		list-style: none;
		text-align: center;
		color: #ccc;
	}
	.nav a{
		text-decoration: none;
		color: #aaa;
		font-size: 16px;
	}
	.icon{
		filter: grayscale(100%) brightness(200%);
	}

	.wap{
		background-color: #333;
		text-align: center;
		height: 80px;
		color: #fff;
		padding-top: 20px;
		font-size: 14px;
	}
	.wap a{
		color: #aaa;
		text-decoration: none;
	}
	.wap .info{
		margin-top: 10px;
	}
</style>
